const vendorRouter = [
    {
        path:'',
        name:'vendor-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/index.vue'),
        children:[
            {
                path:'',
                name:'role-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視廠商 或 點選新增廠商' }
            },
            {
                path:'create',
                name:'vendor-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/vendor/create.vue')
            },
            {
                path:'detail/:id',
                name:'vendor-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/vendor/detail.vue')
            },
            {
                path:'edit/:id',
                name:'vendor-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/vendor/edit.vue')
            },
        ]
    },
  ]
  export default vendorRouter

  